import React from 'react';
import styles from './index.module.css';
import FleetDashboardV2 from "./FleetDashboardV2";
import { GoogleMapsLoaderProvider } from "../../../../context/GoogleMapsLoaderProvider";

const Tracking = (props: any) => {
  return (
    <div className={styles.screen}>
      <GoogleMapsLoaderProvider>
        <FleetDashboardV2 />
      </GoogleMapsLoaderProvider>
    </div>
  );
}

export default Tracking

